






















import Vue from 'vue'
import ShiftReport from '@/components/shift-and-round-reports/ShiftReport.vue'
import UnitRoundReport from '@/components/shift-and-round-reports/UnitRoundReport.vue'

const enum ReportTypes {
  Shift = 'ShiftReport',
  UnitRound = 'UnitRoundReport',
}

const enum ReportTypeIndexes {
  Shift = 0,
  UnitRound = 1,
}

type ComponentData = {
  activeTab: number
}

export default Vue.extend({
  components: {
    ShiftReport,
    UnitRoundReport,
  },

  data(): ComponentData {
    return {
      activeTab: 0,
    }
  },

  computed: {
    showShiftReport() {
      return this.activeTab === ReportTypeIndexes.Shift
    },
    showUnitRoundReport() {
      return this.activeTab === ReportTypeIndexes.UnitRound
    },
    currentTabComponent() {
      return this.showShiftReport ? ReportTypes.Shift : ReportTypes.UnitRound
    },
    reportTypeTabOptions() {
      return [
        {
          label: 'Shift Report',
          isActive: this.showShiftReport,
        },
        {
          label: 'Unit Round Report',
          isActive: this.showUnitRoundReport,
        },
      ]
    },
  },
})
